module.exports = __webpack_public_path__ + "img/icon-qr-scan.c3fbed5c.svg";